// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"17":"activityDetailsView","962":"home"}[chunkId] || chunkId) + "." + {"17":"df5360a2","857":"cea5c6dc","962":"9e945e54"}[chunkId] + ".chunk.css";
};